import * as styles from './CheckBox.css';
import { NavCheckSmallLineIcon, NavCheckSmallNoneIcon } from '@/assets/icons';
import { InputHTMLAttributes } from 'react';

export type CheckBoxProps = {
  value: boolean;
} & Pick<
  InputHTMLAttributes<HTMLInputElement>,
  'id' | 'disabled' | 'onChange' | 'onClick'
>;

const CheckBox = (props: CheckBoxProps) => {
  const { value, ...restProps } = props;
  const Icon =
    value && !props.disabled ? NavCheckSmallLineIcon : NavCheckSmallNoneIcon;

  return (
    <span onClick={(e) => e.stopPropagation()} className={styles.container}>
      <input
        type="checkbox"
        checked={value}
        className={styles.input}
        aria-checked={value}
        {...restProps}
      />
      <Icon width={24} height={24} />
    </span>
  );
};

export default CheckBox;
